import { Card as BlueprintCard } from '@blueprintjs/core';
import { ChatLaunch, SelectWindow } from '@carbon/icons-react';
import * as React from 'react';

import { useVoiceboxSchema } from 'bones/components/molecules/Voicebox/context/VoiceboxSchema';
import { useVoiceboxSettings } from 'bones/components/molecules/Voicebox/context/VoiceboxSettings';
import { Icon } from 'bones/design-system/components/icons/Icon';
import { Body } from 'bones/design-system/components/typography/Body';
import { Heading } from 'bones/design-system/components/typography/Heading';

export interface VoiceboxLandingCardsProps {
  sendMessage: (message: string) => void;
  sendMessageDisabled: boolean;
}

export const VoiceboxLandingCards: React.VFC<VoiceboxLandingCardsProps> = ({
  sendMessage,
  sendMessageDisabled,
}) => {
  const { config, copy, testIds } = useVoiceboxSchema();
  const { databasesById, settings } = useVoiceboxSettings();

  const examples =
    config.examples || databasesById[settings.databaseId]?.examples;

  if (!examples?.length) {
    return <div className="vb-voicebox-landing-cards" />;
  }

  return (
    <div className="vb-voicebox-landing-cards">
      <div className="vb-voicebox-landing-cards-help">
        <Icon IconComponent={SelectWindow} size="sm" />
        <Body size="sm">{copy.message.example.help}</Body>
      </div>
      <div className="vb-voicebox-landing-cards-scroll">
        <div className="vb-voicebox-landing-cards-list">
          {examples.map((example, exampleIdx) => (
            <BlueprintCard
              // eslint-disable-next-line react/no-array-index-key
              key={exampleIdx}
              className="vb-voicebox-landing-card"
              data-testid={testIds.messages.example.card(example, exampleIdx)}
              interactive={!sendMessageDisabled}
              onClick={
                sendMessageDisabled ? undefined : () => sendMessage(example)
              }
            >
              <div className="vb-voicebox-landing-card-header">
                <Icon IconComponent={ChatLaunch} size="md" />
                <span className="vb-voicebox-landing-card-label">
                  <Heading size="sm" weight="light">
                    Q
                  </Heading>
                  <Heading size="sm" weight="light">
                    {copy.drawer.example(exampleIdx)}
                  </Heading>
                </span>
              </div>
              <Heading
                className="vb-voicebox-landing-card-body"
                size="md"
                weight="semibold"
              >
                {example}
              </Heading>
            </BlueprintCard>
          ))}
        </div>
      </div>
    </div>
  );
};
